export const getIsLoggedIn = ({ state }) => state.app.isLoggedIn;
export const getIsLoaderOpen = ({ state }) => state.app.isLoaderOpen;

export const getNotificationsList = ({ state }) => state.app.notificationsList;

export const getNotificationsLength = ({ state }) => state.app.notificationsLength;

export const getIsNotificationsAlertOpen = ({ state }) => state.app.isNotificcationAlertOpen;
